/**
 * @owner @Appboy/messaging-experience
 */

import { developerRemoteLookupValidators } from "@schemas/remoteLookup/developerRemoteLookupSchema";
import type {
  DeveloperRemoteLookupId,
  DeveloperRemoteLookupItem,
  DeveloperRemoteLookupFilters,
} from "@schemas/types";
import type { z } from "zod";

import type { RemoteLookupProvider } from "./types";

export const developerProvider: RemoteLookupProvider<
  DeveloperRemoteLookupId,
  DeveloperRemoteLookupItem,
  DeveloperRemoteLookupFilters
> = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => `${item.email} ${item.first_name} ${item.last_name}`,
  validators: {
    ...developerRemoteLookupValidators,
    item: developerRemoteLookupValidators.item as z.ZodType<DeveloperRemoteLookupItem>,
  },
};
